module.exports = __webpack_public_path__ + "media/images/emprelatam-user-image-3d459641.png";